// covered-by: packages/commons-node/src/libs/__tests__/ssoStateNonce.test.ts
import { z } from "zod";

export enum ModelsNames {
  Enterprise = "Enterprise",
  Event = "Event",
  User = "User",
  Note = "Note",
  Team = "Team",
  Ticket = "Ticket",
  UserChat = "UserChat",
  AskPunttChat = "AskPunttChat",
  AskPunttProject = "AskPunttProject",
  AskPunttProjectFeed = "AskPunttProjectFeed",
  AskPunttUserSeen = "AskPunttUserSeen",
  AskPunttLauncherView = "AskPunttLauncherView",
  AskPunttUserProfile = "AskPunttUserProfile",
  ApprovalEvent = "ApprovalEvent",
  ApprovalNote = "ApprovalNote",
  AskPunttParticipationTask = "AskPunttParticipationTask",
  Workflow = "Workflow",
  /** One-time SSO authorize→callback nonces (consumed on callback). */
  SsoStateNonce = "SsoStateNonce",
  KnowledgeSource = "KnowledgeSource",
  KnowledgeRule = "KnowledgeRule",
  KnowledgeActivity = "KnowledgeActivity",
}

export const modelNamesSchema = z.nativeEnum(ModelsNames);

export enum SubReferenceTypes {
  TicketMessage = "T",
  TicketRevision = "TicketRevision",
  TicketReview = "TicketReview",
}

export const subReferenceTypesSchema = z.nativeEnum(SubReferenceTypes);
